import React from "react";
import { useSelector } from "react-redux";
import { getDate } from "utils/formatDate";
import { formatNumber } from "utils/currencyFormat";
import { BtnChiTietHopDong } from "../ThuChiHopDong/ChiTietHopDong/BtnChiTietHopDong";

export const ContentTableXuaHoaDon = ({
  listQuanLyThuChiHopDong,
  isDuDungPhiPhatDongLaiTatToan,
  isSuDungPhiPhatDongLaiCham,
  SuDungTatToanSom,
  showStatus = false,
  selectedIds = [],
  onSelectedIdsChange = () => {},
  dataSearch,
}) => {
  const listQuanLyThuChiHopDongFull = useSelector(
    (state) => state.listQuanLyThuChiHopDongFull,
  );

  const handleSelectRow = (item) => {
    const isSelected = selectedIds.some((s) => s.ThuChiID === item.ThuChiID);
    const newSelected = isSelected
      ? []
      : [
          {
            ThuChiID: item.ThuChiID,
            ValueLai: item.ValueLai,
            OtheFeeHangKy: item.OtheFeeHangKy,
            OtherFee:
              item.OtherFee +
              item.PhiKho +
              item.PhiPhatDongLai +
              item.PhiPhatTatToan +
              item.PhiHoaHongTraGop,
            IsXuatHoaDon: item.IsXuatHoaDon,
            nameCus: item.nameCus || item.Name,
            ChoVayId: item.ChoVayID,
            Time: item.Time,
          },
        ];
    onSelectedIdsChange(newSelected);
  };

  return listQuanLyThuChiHopDong.map((item, index) => (
    <div
      className={
        "custom-table-row" +
        (selectedIds.some((s) => s.ThuChiID === item.ThuChiID) ? " active" : "")
      }
      style={{ border: "none", cursor: "pointer" }}
      onClick={() => handleSelectRow(item)}
    >
      <div className="custom-table-cell-v2 username-cell flex-basis-5 flex-mobile-5 disk-m5obile">
        <span className="mobile-column-name">STT</span>
        <div
          className="center-wrapper color7"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "8px",
          }}
        >
          <p className="text-center" style={{ margin: 0 }}>
            {index +
              1 +
              (dataSearch.pageIndex - 1) * (dataSearch.pageSize || 20)}
          </p>
        </div>
      </div>

      <div className="custom-table-cell-v2 flex-basis-8 flex-mobile-10 center-flex">
        <span className="mobile-column-name">Ngày giao dịch</span>
        <div className="center-wrapper color7">
          <p className="text-center">{getDate(item.Time)}</p>
        </div>
      </div>

      <div className="custom-table-cell-v2 flex-basis-9 flex-mobile-12 center-flex">
        <span className="mobile-column-name">Số hóa đơn</span>
        <div className="center-wrapper color7">
          <p className="text-center">{item.SoHoaDon}</p>
        </div>
      </div>

      <div className="custom-table-cell-v2 flex-basis-9 flex-mobile-12">
        <span className="mobile-column-name ">Tên khách hàng</span>
        <div className="center-wrapper color7 word-break">
          <p>{item.Name}</p>
        </div>
      </div>

      <div className="custom-table-cell-v2 flex-basis-6 flex-mobile-12">
        <span className="mobile-column-name">Loại</span>
        <div className="center-wrapper color7">{item.TypeName}</div>
      </div>

      <div className="custom-table-cell-v2 flex-basis-10 flex-mobile-15">
        <span className="mobile-column-name">Thu</span>
        <div className="center-wrapper ">
          {item.Value > 0 ? (
            <p className=" text-right color-xanh-bold">
              {formatNumber(item.Value)}
            </p>
          ) : (
            <p className=" text-right color-xanh-bold">0</p>
          )}
        </div>
      </div>

      <div className="custom-table-cell-v2 flex-basis-9 flex-mobile-13">
        <span className="mobile-column-name">Phí kho</span>
        <div className="center-wrapper color7">
          <p className=" text-right color-xanh-bold">
            {formatNumber(item.PhiKho)}
          </p>
        </div>
      </div>

      <div className="custom-table-cell-v2 flex-basis-9 flex-mobile-13">
        <span className="mobile-column-name">Phí khác</span>
        <div className="center-wrapper color7">
          <p className=" text-right color-xanh-bold">
            {formatNumber(item.OtherFee)}
          </p>
        </div>
      </div>

      {(isSuDungPhiPhatDongLaiCham || isDuDungPhiPhatDongLaiTatToan) && (
        <>
          <div className="custom-table-cell-v2 flex-basis-9 flex-mobile-13">
            <span className="mobile-column-name">Phạt chậm đóng lãi</span>
            <div className="center-wrapper color7">
              <p className=" text-right color-xanh-bold">
                {formatNumber(
                  isDuDungPhiPhatDongLaiTatToan
                    ? item.PhiPhatDongLai
                    : item.PhiDongLaiCham,
                )}
              </p>
            </div>
          </div>
        </>
      )}

      {(isDuDungPhiPhatDongLaiTatToan || SuDungTatToanSom) && (
        <div className="custom-table-cell-v2 flex-basis-9 flex-mobile-13">
          <span className="mobile-column-name">Phạt tất toán sớm</span>
          <div className="center-wrapper color7">
            <p className="text-right">{formatNumber(item.PhiPhatTatToan)}</p>
          </div>
        </div>
      )}

      {(listQuanLyThuChiHopDongFull.IsHoaHongTraGop !== "0" ||
        listQuanLyThuChiHopDongFull.TotalPhiPhat > 0) && (
        <>
          <div className="custom-table-cell-v2 flex-basis-9 flex-mobile-13">
            <span className="mobile-column-name">Phí phạt</span>
            <div className="center-wrapper color7">
              <p className=" text-right">{formatNumber(item.Amercement)}</p>
            </div>
          </div>
          <div className="custom-table-cell-v2 flex-basis-9 flex-mobile-13">
            <span className="mobile-column-name">Phí hoa hồng</span>
            <div className="center-wrapper color7">
              <p className="  text-right">
                {formatNumber(item.PhiHoaHongTraGop)}
              </p>
            </div>
          </div>
        </>
      )}

      <div className="custom-table-cell-v2 flex-basis-9 flex-mobile-13">
        <span className="mobile-column-name">Tiền gốc</span>
        <div className="center-wrapper ">
          <p className=" text-right color-cam-bold">
            {formatNumber(item.ValueGoc)}
          </p>
        </div>
      </div>

      <div className="custom-table-cell-v2 flex-basis-9 flex-mobile-13">
        <span className="mobile-column-name">Tiền lãi</span>
        <div className="center-wrapper">
          <p className="text-right color-xanh-bold">
            {formatNumber(item.ValueLai)}
          </p>
        </div>
      </div>

      <div className="custom-table-cell-v2 flex-basis-9 flex-mobile-13">
        <span className="mobile-column-name">Các loại phí</span>
        <div className="center-wrapper ">
          <p className="text-right color-do-bold">
            {formatNumber(item.OtheFeeHangKy)}
          </p>
        </div>
      </div>

      {showStatus && (
        <div className="custom-table-cell-v2 flex-basis-9 flex-mobile-8 action-cell">
          <span className="mobile-column-name">Trạng thái</span>
          <div className="center-wrapper">
            <p className="text-center">
              <span
                className={
                  item.IsXuatHoaDon == 1
                    ? "dong"
                    : item.IsXuatHoaDon == 2
                      ? "canh-bao-no"
                      : item.IsXuatHoaDon == -1
                        ? "canh-bao-red-v2"
                        : "dang-vay"
                }
              >
                {item.IsXuatHoaDon == 1
                  ? "Đã xuất"
                  : item.IsXuatHoaDon == 2
                    ? "Bản nháp"
                    : item.IsXuatHoaDon == -1
                      ? "Hủy"
                      : "Chờ xuất"}
              </span>
            </p>
          </div>
        </div>
      )}
    </div>
  ));
};
